import API_URLS from "../../config/BackendConfig";
import { getToken } from "../../utils/tokenUtils";
import { getRequest, postRequest } from "../../config/AxiosConfig";

const apiBaseUrl = API_URLS.CUSTOMER;
const apiProdUrl = API_URLS.PROD;

const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};


// -------------------------Beneficiary---Group---------------------------//

// Create Beneficiary Group
export const CreateBeneficiaryGroup = async ({
  name,
  description,
}) => {
  try {
    const payload = {
        "name": name,
      "description": description,
    };
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/group/create`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
    } catch (error) {
      console.error('Error in Adding Request Fund', error.response?.data?.message || error.message);
    }
};

// Create Beneficiary Group Report
export const BeneficiaryGroupReport = async (
page = 1) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/group/list?page=${page}`,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to get Report",
    };
  }
};







// Create Beneficiary Group Name Total
export const BeneficiaryGroupReports = async (
total_data = 100) => {
  try {
    const response = await postRequest({
       url: `${apiBaseUrl}beneficiary/group/list`,
      headers: getAuthHeaders(),
        data: { total_data }  // send total_data in body
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to get Report",
    };
  }
};




// Create Beneficiary Details Using Names For Bulk
export const fetchBeneficiaryDetailsByName = async (
beneficiary_group_id) => {
  try {
    const response = await postRequest({
       url: `${apiBaseUrl}beneficiary/group/fetch-beneficiary`,
      headers: getAuthHeaders(),
        data: { beneficiary_group_id }
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to get Report",
    };
  }
};


// Create Beneficiary Details Using Search Names For Bulk
export const fetchBeneficiaryDetailsBySearch = async (
search) => {
  try {
    const response = await postRequest({
       url: `${apiBaseUrl}beneficiary/search-beneficiary`,
      headers: getAuthHeaders(),
        data: { search }
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to get Report",
    };
  }
};




// Create Beneficiary Group Edit
export const BeneficiaryGroupEdit = async (id) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/group/edit`,
      data: { id: String(id) }, 
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    return {
      status: 500,
      type: 'error',
      message: error.response?.data?.message || "Failed to Edit",
    };
  }
};


// Create Beneficiary Group Update
export const BeneficiaryGroupUpdate = async (
id,name,description) => {
  try {
        const payload = {
        "id": id,
        "name": name,
        "description": description
    }
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/group/update`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to update",
    };
  }
};


// Create Beneficiary Group Delete
export const BeneficiaryGroupDelete = async (
id) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/group/delete`,
      data: {id},
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to Delete",
    };
  }
};


// -------------------------Beneficiary--Group--ENd---------------------------//












// -------------------------Beneficiary----Only---------------------------//


// Create Beneficiary
export const CreateBeneficiary = async ({
  name,
  account_number,
  ifsc_code,
  bank_name,
  branch_name,
  is_vendor,
  is_salary,
  beneficiary_group_id,
}) => {
  try {
    const payload = {
      "name": name,
      "account_number": account_number,
      "ifsc_code": ifsc_code,
      "bank_name": bank_name,
      "branch_name": branch_name,
      "is_vendor": is_vendor,
      "is_salary": is_salary,
      "beneficiary_group_id": beneficiary_group_id,
    };
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/create`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to create",
    };
  }
};


// Create Beneficiary Report
export const BeneficiaryReport = async (
page = 1) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/list?page=${page}`,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to get Report",
    };
  }
};


// Create Beneficiary Edit
export const BeneficiaryEdit = async (id) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/edit`,
      data: { id: String(id) }, 
      headers: getAuthHeaders(),
    });

    return response;
  } catch (error) {
    return {
      status: 500,
      type: 'error',
      message: error.response?.data?.message || "Failed to Edit",
    };
  }
};


// Create Beneficiary Update
export const BeneficiaryUpdate = async (
id,name,account_number,ifsc_code,bank_name,branch_name,beneficiary_group_id,is_vendor,is_salary) => {
  try {
        const payload = {
        "id": id,
        "name": name,
        "account_number": account_number,
        "ifsc_code": ifsc_code,
        "bank_name": bank_name,
        "branch_name": branch_name,
        "beneficiary_group_id": beneficiary_group_id,
        "is_vendor" : is_vendor,
        "is_salary" : is_salary
    }
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/update`,
      data: payload,
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to update",
    };
  }
};


// Create Beneficiary Delete
export const BeneficiaryDelete = async (
id) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}beneficiary/delete`,
      data: {id},
      headers: getAuthHeaders(),
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to Delete",
    };
  }
};  


// -------------------------Beneficiary---ENd-------------------------//


// Create Single Payout
export const CreateSinglePayout = async ({
  api_id,
  api_key,
  token_id,
  amount,
  transactionType,
  paymentDescription,
  creditAccountNumber,
  remitterName,
  beneficiaryIFSC,
  beneficiaryName,
  beneficiaryAddress,
  emailId,
  mobileNo,
  payout_account_number,
}) => {
  try {
    const payload = {
      api_id,
      api_key,
      token_id,
      amount,
      transactionType,
      paymentDescription,
      creditAccountNumber,
      remitterName,
      beneficiaryIFSC,
      beneficiaryName,
      beneficiaryAddress,
      emailId,
      mobileNo,
      payout_account_number,
    };

    const response = await postRequest({
       url: `${apiProdUrl}idfc/fund-transfer`,
      // url: "https://javabackend.idspay.in/api/v1/prod/idfc/fund-transfer",
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("CreateSinglePayout Error:", error); // optional
    return {
      success: false,
      message: error.response?.data?.message || "Failed to create",
    };
  }
};

// Create Bulk Payout
export const CreateBulkPayout = async ({
  api_id,
  api_key,
  token_id,
  payout_account_number,
  bulkData, // array of payouts
}) => {
  try {
    const payload = {
      api_id,
      api_key,
      token_id,
    
      payment_transfer_type: "BULK",
        payout_account_number,
      bulkData, // this should be an array of payout objects
    };

    const response = await postRequest({
      url: `${apiProdUrl}idfc/fund-transfer`,
      headers: getAuthHeaders(),
      data: payload,
    });

    return response;
  } catch (error) {
    console.error("CreateBulkPayout Error:", error);
    return {
      success: false,
      message: error.response?.data?.message || "Failed to create bulk payout",
    };
  }
};




// Verfiy Account for Payout using creditorAccountId,ifsc
export const verifyBankPayout = async ({ api_id, api_key, token_id,creditorAccountId,ifscCode}) => {
  try {
    const payload = {
        "api_id": api_id,
        "api_key": api_key,
        "token_id": token_id,
        "creditorAccountId": creditorAccountId,
        "ifscCode": ifscCode
    };

    const response = await postRequest({
      url: `${apiProdUrl}idfc/beneficiary`,
      headers: getAuthHeaders(),
      data: payload,
    });
   
    return response;
  } catch (error) {
    console.error("Error Bank ac Verify:", error.response?.data || error.message);
    throw error;
  }
};



//  Payout List Report
export const PayoutListReport = async (
  page = 1,
  filters = {
    total_data: 10,
    account_number: "",
    beneficiary_name: "",
    amount: 0,
    from_date: "",
    to_date: "",
    txn_type: ""
  }
) => {
  try {
    const response = await postRequest({
      url: `${apiBaseUrl}payout/list?page=${page}`,
      headers: getAuthHeaders(),
      data: filters // This sends the body correctly
    });
    return response;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "Failed to get List",
    };
  }
};
